import { useContext } from 'react';
import { PageContext } from 'contexts';
import { MusicLink } from 'components/MusicLink';
import { GO_COOKIE_PREFERENCES } from 'constants/metrics';
import { FormattedMessage } from 'react-intl';
import { COOKIE_PREFERENCES_LINK } from 'constants/links';

const CookiePreferences = () => {
  const page = useContext(PageContext);
  return (
    <MusicLink
      href={COOKIE_PREFERENCES_LINK}
      kind="accent"
      data-id={`${GO_COOKIE_PREFERENCES}-${page}`}
    >
      <FormattedMessage
        id="cookie-preferences"
        defaultMessage="Cookie Preferences"
      />
    </MusicLink>
  );
};

export default CookiePreferences;
